import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Quote } from "lucide-react";
import { api } from "@/lib/api";
import { Stars } from "@/components/Stars";

export const REVIEW_BTN = "inline-flex items-center justify-center rounded-xl bg-[#053671] px-5 py-2.5 text-sm font-semibold text-white ring-1 ring-white/10 shadow-lg shadow-black/20 transition-[background-color,transform,box-shadow] duration-200 hover:bg-[#0a4a8f] hover:-translate-y-0.5 hover:shadow-xl active:translate-y-0";

// Compact strip of a show's approved listener reviews, with a "Review this show" link. Hidden when there are none.
export const ShowReviews = ({ show }) => {
  const [data, setData] = useState(null);
  useEffect(() => { api.get("/testimonials", { params: { show: show.slug, limit: 3 } }).then((r) => setData(r.data)).catch(() => setData(null)); }, [show.slug]);
  if (!data?.items?.length) return null;
  return (
    <section className="max-w-[1400px] mx-auto px-5 sm:px-8 pb-12" data-testid="show-reviews">
      <div className="flex items-end justify-between gap-4 mb-5 flex-wrap">
        <p className="eyebrow mb-1">Listener reviews</p>
        <Link to={`/review?show=${encodeURIComponent(show.slug)}`} className={REVIEW_BTN} data-testid="show-reviews-write">Review this show</Link>
      </div>
      <div className="grid gap-4 sm:grid-cols-3">
        {data.items.map((t) => (
          <figure key={t.id} className="relative rounded-2xl border border-white/10 bg-white/[0.04] p-5" data-testid="show-review-card">
            <Quote size={26} className="absolute -top-2.5 left-4 text-amber-400/80 fill-amber-400/80 rotate-180" aria-hidden="true" />
            <Stars value={t.rating} size={14} />
            <blockquote className="mt-3 text-sm leading-relaxed text-slate-200 line-clamp-4">{t.text}</blockquote>
            <figcaption className="mt-3 font-display font-black">— {t.name}</figcaption>
          </figure>
        ))}
      </div>
    </section>
  );
};
